
import React from 'react';
import {
    Grid,
    Typography,
} from "@mui/material";
import "./styles.css";

const JobCategory = (props) => {
    const { item } = props
    return (
        <Grid display='flex' className="category">
            <Grid display='flex' flexDirection='column' style={{ marginLeft: '20px' }}>
                <Typography style={{ color: '#008EA1' }}>Job Category</Typography>
                <Typography>{item.jobCategory}</Typography>
            </Grid>
            <Grid display='flex' flexDirection='column' style={{ marginRight: '40%' }}>
                <Typography style={{ color: '#008EA1' }}>Service</Typography>
                <Typography> {item.service} </Typography>
            </Grid>
        </Grid>
    );
};

export default JobCategory;